import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { HomeHero } from '@/components/landing/home/home-hero'
import { FinancingSection } from '@/components/landing/sections/financing-section'
import { GuaranteesSection } from '@/components/landing/sections/guarantees-section'
import { ServiceAreaSection } from '@/components/landing/sections/service-area-section'
import { FaqSection } from '@/components/landing/sections/faq-section'
import { QuoteSection } from '@/components/landing/sections/quote-section'

import {
    ProofSection,
    DiagnoseSection,
    ServicesSection,
    DoorsSection,
    RecentWorkSection,
    PriceGuideSection
} from '@/components/landing/home/home-sections'

const Home: FC = (): ReactNode => {
    return (
        <Layout heroTheme='dark'>
            <Seo description="Garage door repairs and new doors across the Riverton metro. Same-day spring, opener and track repairs, a written price before work starts, and new doors fitted in a day." />

            <HomeHero />
            <ProofSection />
            <DiagnoseSection />
            <ServicesSection />
            <DoorsSection />
            <RecentWorkSection />
            <PriceGuideSection />

            <FinancingSection
                title="New doors from $49 a month."
                description="Pay for a new door or opener over 12–60 months, with a 12-month term at 0% APR on approved credit. Seeing your rate leaves your credit score untouched."
            />

            <GuaranteesSection />
            <ServiceAreaSection />
            <FaqSection />
            <QuoteSection />
        </Layout>
    )
}

export default Home
